import React, { useEffect,  useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import { FiMenu } from "react-icons/fi";

import { format } from "date-fns";

import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import ColourTable from "../../../../components/Tables/ColourTable";
import ColourChart from "../../../../components/Charts/ColourChart";
import {
  ColorMasterwise13Table,
  ColorMasterwise13TableFun,
  ColourFilter,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";

export const Fsn = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { ColourfilterData, ColorMasterwise13TableData } = useSelector(
    (state) => state.InwardAnylysisSlice,
  );

  console.log(ColorMasterwise13TableData);

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const [showFilter, setShowFilter] = useState(false);
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  const DEFAULT_MONTH = "04";

  const selectedYearObj = DataMain?.AC_Year_List?.find(
    (y) => String(y.AcYearID) === String(FinancialYear),
  );

  const parseAcYear = (acYearStr) => {
    if (!acYearStr) return null;

    const [start, end] = acYearStr.split(" - ");

    const formatDate = (d) => {
      const [dd, mm, yyyy] = d.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };

    return {
      start: formatDate(start),
      end: formatDate(end),
    };
  };

  const financialYearRange = parseAcYear(selectedYearObj?.AcYear);

  const FinYearStart = financialYearRange?.start;
  const FinYearEnd = financialYearRange?.end;

  const getMonthId = (monthValue) => {
    if (!FinYearStart || !FinYearEnd) return "";

    const startYear = new Date(FinYearStart).getFullYear();
    const endYear = new Date(FinYearEnd).getFullYear();

    // Jan–Mar → next year
    const year = Number(monthValue) <= 3 ? endYear : startYear;
    console.log(year);

    return `${year}${monthValue}`; // ex: 202404
  };

  const MonthListdata = [
    { name: "April", value: "04" },
    { name: "May", value: "05" },
    { name: "June", value: "06" },
    { name: "July", value: "07" },
    { name: "August", value: "08" },
    { name: "September", value: "09" },
    { name: "October", value: "10" },
    { name: "November", value: "11" },
    { name: "December", value: "12" },
    { name: "January", value: "01" },
    { name: "February", value: "02" },
    { name: "March", value: "03" },
  ];
  const monthList = MonthListdata?.map((item) => ({
    label: item?.name,
    value: item?.value,
  }));

  const itemSubGroupList = ColourfilterData?.ItemSGroup?.map((item) => ({
    label: item?.ItemSubGroupName,
    value: item?.ItemSubGroupID,
  }));

  const [filters, setFilters] = useState({
    month: [],
    itemSubGroup: [],
  });

  const [search, setSearch] = useState({
    month: "",
    itemSubGroup: "",
  });

  useEffect(() => {
    dispatch(ColourFilter());

    const monthIds = getMonthId(DEFAULT_MONTH);

    dispatch(
      ColorMasterwise13Table({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        monthIds: monthIds,
      }),
    );
  }, [Firm, FinancialYear, dispatch]);

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      let updatedSelected;

      if (type === "month") {
        updatedSelected = prev.month.includes(item.value) ? [] : [item.value];
      } else {
        const selected = prev[type];
        updatedSelected = selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value];
      }

      const newFilters = {
        ...prev,
        [type]: updatedSelected,
      };

      if (type === "itemSubGroup" || type === "month") {
        dispatch(ColorMasterwise13TableFun());
        const finalMonth = newFilters.month[0] || DEFAULT_MONTH;
        const monthIds = getMonthId(finalMonth);

        const payload = {
          FirmIDs: Firm,
          AcYearIDs: FinancialYear,
          ItemSubG: newFilters.itemSubGroup.join(","),
          monthIds: monthIds,
        };

        dispatch(ColorMasterwise13Table(payload));
      }

      return newFilters;
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);
    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, val) => {
    setSearch((prev) => ({ ...prev, [type]: val }));
  };

  const Detail1Columns = [
    {
      label: "Class",
      key: "class",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Opening", key: "Opening", align: "right", format: "true" },
    {
      label: "Opening Amount",
      key: "OpeningAmt",
      align: "right",
      format: "true",
    },
    { label: "Inward", key: "Inward", align: "right", format: "true" },
    {
      label: "Inward Amount",
      key: "InwardAmt",
      align: "right",
      format: "true",
    },
    { label: "Outward", key: "Outward", align: "right", format: "true" },
    {
      label: "Outward Amount",
      key: "OutwardAmt",
      align: "right",
      format: "true",
    },
    { label: "Closing", key: "Closing", align: "right", format: "true" },
    {
      label: "Closing Amount",
      key: "ClosingAmt",
      align: "right",
      format: "true",
    },
    { label: "Cons %", key: "ConsPct", align: "right", format: "true" },
    { label: "Stock %", key: "StockPct", align: "right", format: "true" },
    { label: "Item Count", key: "itemcount", align: "right", format: "true" },
  ];

  const Detail1Row = (ColorMasterwise13TableData?.Detail1 || []).map((row) => ({
    ...row,
  }));

  const DetailColumns = [
    {
      label: "Sr No",
      key: "srNo",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Class",
      key: "Class",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Item Name",
      key: "itemname",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Opening", key: "Opening", align: "right", format: "true" },
    { label: "Opening Amt", key: "OpeningAmt", align: "right", format: "true" },
    { label: "Inward", key: "Inward", align: "right", format: "true" },
    { label: "Inward Amt", key: "InwardAmt", align: "right", format: "true" },
    { label: "Outward", key: "Outward", align: "right", format: "true" },
    { label: "Outward Amt", key: "OutwardAmt", align: "right", format: "true" },
    { label: "Closing", key: "Closing", align: "right", format: "true" },
    { label: "Closing Amt", key: "ClosingAmt", align: "right", format: "true" },
    { label: "Cons %", key: "ConsPct", align: "right", format: "true" },
    {
      label: "Prog Cons %",
      key: "ProgressiveConsPct",
      align: "right",
      format: "true",
    },
    { label: "Stock %", key: "StockPct", align: "right", format: "true" },
    { label: "Rate", key: "Rate", align: "right", format: "true" },
  ];

  const DetailRow = (ColorMasterwise13TableData?.Detail || []).map(
    (row, index) => ({
      srNo: index + 1, // ✅ Sr No added
      ...row,
    }),
  );

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!ColorMasterwise13TableData || ColorMasterwise13TableData === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >

      {/* MOBILE BUTTON */}
      <div className="d-lg-none text-end mb-2">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            border: "none",
          }}
        >
          <FiMenu />
        </Button>
      </div>

      {/* OFFCANVAS */}
      <Offcanvas show={showFilter} onHide={() => setShowFilter(false)}
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        }}
      >
        <Offcanvas.Header closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
          style={{ color: isdark === "light" ? "#000" : "#FFF", }} >
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* FSN FILTER */}
            <ColourFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(v) => handleSearch("month", v)}
              selectedItems={filters.month}
              toggleItem={(i) => toggleItem("month", i)}
              selectAll={() => selectAll("month", monthList)}
            />

            {/* FILTER 2 */}
            <ColourFilterBox
              title="Item Sub Group"
              items={itemSubGroupList}
              search={search.itemSubGroup}
              setSearch={(v) => handleSearch("itemSubGroup", v)}
              selectedItems={filters.itemSubGroup}
              toggleItem={(i) => toggleItem("itemSubGroup", i)}
              selectAll={() => selectAll("itemSubGroup", itemSubGroupList)}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row>
        {/* DESKTOP FILTER */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* FSN FILTER */}
            <ColourFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(v) => handleSearch("month", v)}
              selectedItems={filters.month}
              toggleItem={(i) => toggleItem("month", i)}
              selectAll={() => selectAll("month", monthList)}
            />

            {/* FILTER 2 */}
            <ColourFilterBox
              title="Item Sub Group"
              items={itemSubGroupList}
              search={search.itemSubGroup}
              setSearch={(v) => handleSearch("itemSubGroup", v)}
              selectedItems={filters.itemSubGroup}
              toggleItem={(i) => toggleItem("itemSubGroup", i)}
              selectAll={() => selectAll("itemSubGroup", itemSubGroupList)}
            />
          </div>
        </Col>

        <Col xl={9} lg={8}>
          {/* 🔷 CHART */}
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                letterSpacing: "1px",
                fontSize: "18px"
              }}
            >


              FSN ANALYSIS CHART
            </div>

            <div>
              <ColourChart
                data={
                  ColorMasterwise13TableData?.Detail1?.map((row) => ({
                    label: row.class,
                    value:
                      Number(row.OpeningAmt || 0) +
                      Number(row.InwardAmt || 0) +
                      Number(row.OutwardAmt || 0) +
                      Number(row.ClosingAmt || 0),
                  })) || []
                }
                labelKey="label"
                valueKey="value"
              />
            </div>
          </div>

          {/* 🔷 TABLE */}
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              marginTop: "20px",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              FSN SUMMARY
            </div>

            <ColourTable columns={Detail1Columns} data={Detail1Row} />
          </div>

          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              marginTop: "20px",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              FSN SUMMARY
            </div>

            <ColourTable columns={DetailColumns} data={DetailRow} />
          </div>
        </Col>
      </Row>
    </div>
  );
};
